import { useLocation } from 'react-router-dom';

import { computeTier } from '@flintmint/core-shared/utils';
import { Banner } from '@flintmint/web-shared/components/banner';

import { isPastDue, isPendingFirstCharge } from '@/features/billing/billing-state';
import { useOpenPortal } from '@/features/billing/use-open-portal';
import { useUserAccount } from '@/hooks/use-user-account';

/**
 * Persistent notice while the subscription is `past_due`: a failed renewal, or a first payment that never went through.
 * None for a comped account, whose AI use the payment does not limit.
 */
export const PaymentIssueBanner = () => {
  const { account } = useUserAccount();
  const { pathname, search } = useLocation();
  const { openPortal, opening } = useOpenPortal(pathname + search);

  const subscription = account?.stripeSubscription;
  if (!isPastDue(subscription) || computeTier(account) === 'comped') return null;

  const firstPayment = isPendingFirstCharge(subscription);

  return (
    <Banner
      type="neutral"
      title={firstPayment ? 'Your first payment failed' : 'Your renewal payment failed'}
      message={
        firstPayment
          ? 'Your plan has not started. You’re on Free. Manage the payment to pay or stop the pending plan.'
          : 'Update your payment method to restore full AI access.'
      }
      action={{ label: 'Update payment method', onClick: () => void openPortal(), disabled: opening }}
    />
  );
};
